export default __webpack_public_path__ + "static/media/afterparty-banner-landscape.f10c984c.jpg";